import { JiraId } from '@anecdotes/data-store';
import { jiraTicketIDExtractor } from '../jira-ticket-id/jira-ticket-id.extractor';

export function serviceTicketIDExtractor(serviceId: string, ticketIdOrLink: string): string | null {
  switch (serviceId) {
    case JiraId:
      return jiraTicketIDExtractor(ticketIdOrLink);
  }

  return null;
}
